import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EbwModalService } from '@ebw-monorepo/modal';
import { PsaService } from '../../../../services/psa.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'ebw-monorepo-update-rel-action-value',
  templateUrl: './update-rel-action-value.component.html',
  styleUrls: ['./update-rel-action-value.component.scss']
})
export class UpdateRelActionValueComponent implements OnInit {
  relData: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _psaService: PsaService,
    private _dialogRef: MatDialogRef<UpdateRelActionValueComponent>,
    private _ebwModalService: EbwModalService
  ) {}

  ngOnInit() {
    this.relData = { ...this.data };
  }

  onCancel = () => this._dialogRef.close();

  /**
   * Method to modify the probability of the relationship
   */
  async onSave() {
    try {
      const body = {
        rel_entity_evento_rischio_id: this.relData.rel_entity_evento_rischio_id,
        actions: [
          {
            azione_mitigatrice_id: this.relData.azione_mitigatrice_id,
            riduzione_probabilita: this.relData.riduzione_probabilita,
            responsabile: this.relData.responsabile,
            pianificazione: this.relData.pianificazione,
            avanzamento: this.relData.avanzamento,
            costi: this.relData.costi,
            validazione: this.relData.validazione,
            tipologia_di_monitoraggio: this.relData.tipologia_di_monitoraggio,
            parametro_monitorato: this.relData.parametro_monitorato
          }
        ]
      };

      const request = this._psaService._attachActionToEntity(body);
      const response: any = await lastValueFrom(request);
      if (response.error > 0) {
        this._ebwModalService.openErrorModal({ title: response.errorDescription, content: response.message });
        return;
      }
      this._dialogRef.close('UPDATED');
    } catch (error) {}
  }
}
